/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetVwbWorkspaceResources200Response
 */
export interface GetVwbWorkspaceResources200Response {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetVwbWorkspaceResources200Response
     */
    resources?: Array<object>;
}

/**
 * Check if a given object implements the GetVwbWorkspaceResources200Response interface.
 */
export function instanceOfGetVwbWorkspaceResources200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetVwbWorkspaceResources200ResponseFromJSON(json: any): GetVwbWorkspaceResources200Response {
    return GetVwbWorkspaceResources200ResponseFromJSONTyped(json, false);
}

export function GetVwbWorkspaceResources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVwbWorkspaceResources200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resources': !exists(json, 'resources') ? undefined : json['resources'],
    };
}

export function GetVwbWorkspaceResources200ResponseToJSON(value?: GetVwbWorkspaceResources200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resources': value.resources,
    };
}

